import { jsx } from "react/jsx-runtime";
import { ColorPickerBody } from "./components/ColorPickerBody.js";
import { ColorPickerContextProvider } from "./components/ColorPickerContextProvider/ColorPickerContextProvider.js";
function ColorPicker(props) {
  const { picker, palette, trigger, testId } = props;
  return /* @__PURE__ */ jsx(ColorPickerContextProvider, { ...props, children: /* @__PURE__ */ jsx(ColorPickerBody, { palette, picker, testId, trigger }) });
}
export {
  ColorPicker
};
//# sourceMappingURL=ColorPicker.js.map
